import React from 'react';
import { PageHeader } from 'antd';
import { useGetBuyersQuery } from '../../../app/api/userApiSlice';
import BuyerTable from '../containers/BuyerTable';

const ListBuyers: React.FC = () => {
  const { data: buyers, isLoading } = useGetBuyersQuery(undefined, {
    selectFromResult: ({ data, isLoading }) => {
      return {
        data: data?.filter((buyer) => buyer.status.id === 2 || buyer.status.id === 3),
        isLoading,
      };
    },
  });

  return (
    <>
      <PageHeader className='site-page-header' title='Buyers' extra={[]} />
      <BuyerTable buyers={buyers} isLoading={isLoading} />
    </>
  );
};

export default ListBuyers;
